import {useSelector} from "react-redux";
import {RootState} from "@/store";
import BookingInsightPieLayoutResult
  , {
  PieChartData,
  PieLayoutSummaryData, PieLayoutTableData
} from "@/pages/Report/BookingInsightPieLayoutResult";
import {currencyFormat} from "@/utils";
import {pieColors} from "@/pages/Report/constant";

const BookingCourtResult
  = () => {
  const bookingCourt = useSelector((state: RootState) => state.bookingInsight.state.bookingCourt)
  const details = bookingCourt?.details ?? []
  const summaryData = {
    totalHours: bookingCourt?.total_hours ?? 0,
    totalValues: bookingCourt?.total_revenue ?? 0
  } as PieLayoutSummaryData

  const tableData = {
    headers: ['COURTS', 'HOURS', 'VALUES'],
    data: bookingCourt?.details?.map(d => {
      const courtName = d.court_name
      return [courtName, d.total_hours, currencyFormat(d.total_revenue)]
    })
  } as PieLayoutTableData

  const pieChartData = {
    labels: details.map(d => d.court_name ?? ''),
    datasets: [
      {
        label: 'Total Hours',
        data: details.map(d => d.total_hours),
        borderColor: pieColors,
        backgroundColor: pieColors,
        borderWidth: 1
      }
    ]
  } as PieChartData

  return (
    <>
      {
        bookingCourt &&
        <BookingInsightPieLayoutResult
          pieChartData={pieChartData}
          tableData={tableData}
          summaryData={summaryData} />
      }
    </>
  );
};

export default BookingCourtResult
;